import { styled } from "@mui/system";
import { Divider } from "@mui/material";

export const SidebarDivider = styled(Divider)`
  margin: 8px 0;
`;
